export const GET_CLIENT_TOKEN_QUERY = `
  query getClientToken($clientName: String!, $password: String!) {
    validateClient(clientName: $clientName, password: $password) {
      error
      clientName
      token
    }
  }
`;
export const GET_OFFICER_DATA_QUERY = `
  query getOfficerData($county: String!, $username: String!) {
    getOfficerByUsername(county: $county, username: $username) {
      __typename,

      ...on OfficerData {
        firstName
        lastName
      }

      ...on InvalidUserName {
        message
      }

      ...on AccessDenied {
        message
      }
    }
  }
`;
export const GET_OFFICER_REFRESH_TOKEN_QUERY = `
  query officerRefreshToken($refreshToken: String!) {
    officerRefreshToken(refreshToken: $refreshToken) {
      error
      username
      token
      refreshToken
      counties {
        code
        value
        label
      }
      role
      firstName
      lastName
      passwordExpired
    }
  }
`;
